import { PublicUserOrganization } from "../../__generated__/graphql";
import Avatar from "../Avatar";

interface SelectedMembersDisplayProps {
  members: PublicUserOrganization[];
  onRemove?: (memberId: string) => void;
  maxHeight?: string;
}

export default function SelectedMembersDisplay({
  members,
  onRemove,
  maxHeight = "200px",
}: SelectedMembersDisplayProps) {
  if (members.length === 0) {
    return null;
  }

  return (
    <div
      className="flex flex-wrap gap-2 overflow-y-auto custom-scrollbar p-2 bg-dark/50 rounded-lg border border-border"
      style={{ maxHeight }}
    >
      {members.map((member) => (
        <div
          key={member.id}
          className="flex items-center gap-2 bg-card border border-border rounded-full pl-1 pr-2 py-1 group"
        >
          <Avatar userOrganization={member} size="xs" />
          <span className="text-sm text-primary truncate max-w-[120px]">
            {member.name}
          </span>
          {onRemove && (
            <button
              type="button"
              className="w-4 h-4 rounded-full bg-border hover:bg-red-500/80 flex items-center justify-center text-xs text-secondary hover:text-white transition-colors"
              onClick={() => onRemove(member.id)}
            >
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
